import axios from "../../adminCompenents/config/axiosConfig";

class CommentService {
  // Get comments for a product
  async getCommentsByProduct(productId) {
    try {
      const response = await axios.get(`/comments/product/${productId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching comments:", error);
      throw error;
    }
  }

  // Create a new comment
  async createComment(commentData) {
    try {
      const response = await axios.post("/comments", commentData);
      return response.data;
    } catch (error) {
      console.error("Error creating comment:", error);
      throw error;
    }
  }

  // Update a comment
  async updateComment(commentId, commentData) {
    try {
      const response = await axios.patch(`/comments/${commentId}`, commentData);
      return response.data;
    } catch (error) {
      console.error("Error updating comment:", error);
      throw error;
    }
  }

  // Delete a comment
  async deleteComment(commentId) {
    try {
      const response = await axios.delete(`/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting comment:", error);
      throw error;
    }
  }
}

export default CommentService;
